import { createBrowserRouter, redirect } from 'react-router-dom'
import SpaceHomePageContainer from './spaces/SpaceHomePageContainer.tsx'
import { LoginPage } from './core/auth/LoginPage.tsx'
import { RegisterPage } from './core/auth/RegisterPage.tsx'
import { localStorageKeys } from './core/configs/local-storage-keys'
import App from './core/app-shell/App.tsx'
import CreateObjectTypePage from './object-types/create-type-page/CreateObjectTypePage.tsx'
import { CollectionPage } from '@/objects/collection-view/CollectionPage.tsx'

function requireAuthLoader() {
  if (!localStorage.getItem(localStorageKeys.AuthToken)) {
    return redirect('/auth')
  }
  return null
}

export const appRouter = createBrowserRouter([
  { path: '/auth', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  {
    element: <App />,
    children: [
      {
        path: '/',
        loader: requireAuthLoader,
        element: <SpaceHomePageContainer />,
      },
      {
        path: '/newType',
        loader: requireAuthLoader,
        element: <CreateObjectTypePage />,
      },
      {
        path: '/collection',
        loader: requireAuthLoader,
        element: <CollectionPage />,
      },
    ],
  },
])
